<template>
  <div id="cookie-settings">
      <cookie-settings-banner
        v-if="isCookieNotAccepted"
        @settingsBtnClicked="handleCookieSettingsClick"
        class="cookie-settings"
      />
    <transition
      mode="out-in"
      name="fade"
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut  animate__faster"
    >
      <cookie-settings-modal
        v-if="isCookieModalVisible"
        @settingsSubmitted="handleSettingsSubmit"
      />
    </transition>
  </div>
</template>

<script>
import CookieSettingsModal from './CookieSettingsModal.vue';
import CookieSettingsBanner from './CookieSettingsBanner.vue';

export default {
    name: 'CookieSettings',
    components: {
        CookieSettingsModal,
        CookieSettingsBanner
    },
     data() {
    return {
      isMobile: false,
      isCookieModalVisible: false,
    };
  },
    methods: {
      handleResize() {
        const pageWidth = document.body.clientWidth;

        if (pageWidth < 768) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      },
      handleSettingsSubmit() {
        this.isCookieModalVisible = false;
        window['ga-disable-UA-152001488-1'] = false;
      },
      handleCookieSettingsClick() {
        this.openCookieSettingsModal();
      },
      openCookieSettingsModal() {
        this.isCookieModalVisible = true;
      }
    },
    computed: {
      isCookieNotAccepted() {
        return this.$cookies.get('cookie_status') === null;
      }
    },
    created() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
      if(this.isCookieNotAccepted) {
        window['ga-disable-UA-152001488-1'] = true;
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },
}
</script>

<style lang="scss" scoped>
#cookie-settings {
  .cookie-settings {
    position: fixed;
    bottom: 27px;
    left: 50%;
    transform: translateX(-50%);
    z-index: z('cookie-settings');

    @media screen and (max-width: 575px) {
      width: calc(100% - 30px);
    }
  }
}
</style>